import React from 'react';
import { getConfiguration } from '../data/utils';
import { useFetch } from '../data/fetch/useFetch';
import { concatUrlPathnames } from '../data/sport-utils';
import { systemCode, xs_languageCode, xs_product_code_xcasino_desktop } from '..';
    
function parseCasinoGames(data) {
    let result = {
        title: 'Top Slots',
        games: []
    };

    try {
        const parsedData = JSON.parse(data.templates[0].dynamicData).rows[0].components[0];
        result.title = parsedData.title;
        result.games = Object.values(parsedData.games).map(obj => {
            const entries = Object.entries(obj)[0];
            const [id, img] = [entries[0], entries[1]];
            return { id, img };
        });
    } catch (e) {
        console.error(e);
    }

    return result;
}

function parseGamesSeoPathnamesData(data) {
    let toReturn = {};
    if(data) {

        Object.keys(data).forEach((k) => {
            const pnGame = (data[k]?.[systemCode] || data[k]?.['DEFAULT'])?.[xs_languageCode];
            toReturn[k] = pnGame;
        })
    }

    return toReturn;
}

function Content(props) {
    let basePath = null;

    const gamesList = props.data.map(g => g.id).join(';');

    const apiUrl = concatUrlPathnames(window.cg_XSEO_XCASINO_ENDPOINT, '/xcasinoapi/getSeoDataGiochiPathnames');
    const [isLoading, isError, gamesSeoPathnamesData] = useFetch(apiUrl, { codiceProdotto: xs_product_code_xcasino_desktop, giochi: gamesList, skipBaseParams: true }, (data) =>
        parseGamesSeoPathnamesData(data)
    , window.cg_XSEO_XCASINO_ENABLED == 'true');

    try {
        if (window.cg_SEO_URL_MAPPING_REVERSE != null) {
            const cgUrls = JSON.parse(window.cg_SEO_URL_MAPPING_REVERSE);
            basePath = cgUrls.xcasino;
            if (!basePath.startsWith('/')) {
                basePath = `/${basePath}`;
            }
            if (basePath.endsWith('/')) {
                basePath = basePath.slice(0, basePath.length - 1);
            }
        }
    } catch (e) {
        console.error(e);
        return null;
    }

    return (
        <>
            <div className="section-title">
                <span className="title">{props.title}</span>
            </div>
            <div className="top-slots">
                {props.data.map((g,index) => {
                    let gameUrl = `/game/${g.id}`;
                    try {
                        if (gamesSeoPathnamesData?.[g.id]) {
                            gameUrl = concatUrlPathnames(gamesSeoPathnamesData[g.id], '/real'); // Adding the suffix '/real' to run the game
                        }
                    } catch(err) {
                        console.error(err);
                    }

                    return (
                        <React.Fragment key={index}> 
                            <a href={`${concatUrlPathnames(basePath,gameUrl)}`} target="_blank" rel="noreferrer">
                                <img key={g.id} alt='' height="100%" width="100%" src={`${g.img}`} />
                            </a>
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );
}

export default function TopCasinoGames() {
    const conf = getConfiguration();
    
    const [isLoading, isError, data] = useFetch(conf.api.getSportGames, {
        skipBaseParams: true,
        systemCode
    }, (data) =>
        parseCasinoGames(data)
    );
    
    if (isLoading || isError) {
        return null;
    }

    return (
        <Content title={data.title} data={data.games} />
    );
}
